import type { ChatBotAppSettings, ChatBotLoaderSettings } from "./types";

export const CHAT_BOT_APP_DEFAULT_SETTINGS: ChatBotAppSettings = {
  chatName: "Support",
  chatImageUrl: "",
  agentName: "AI Agent",
  agentImage: "",
  welcomeMessage: "Hello! How can I help you?",
  theme: "light",
  senderMessageBackgroundColor: "#1A75D2",
  suggestions: [],
};

export const CHAT_BOT_LOADER_DEFAULT_SETTINGS: ChatBotLoaderSettings = {
  buttonIcon: "default-1",
  buttonColor: "#1A75D2",
  alignment: "right",
  sideSpacing: 20,
  bottomSpacing: 20,
  isButtonHidden: false,
  ctas: [],
  ctaVisual: null,
};

export const MAX_CTA_LENGTH = 100;

export const MAX_CHAT_NAME_LENGTH = 60;

export const MAX_AGENT_NAME_LENGTH = 60;
